import * as React from 'react';
import cx from 'classnames';

import Link from 'components/Link';
import Text from 'components/Text';

import './styles/SelectBox.scss';

export default function SelectBox({
  selected,
  full,
  flush,
  label,
  disabled,
  onSelect,
}: {
  selected: boolean;
  full?: boolean;
  flush?: boolean;
  disabled?: boolean;
  label: string;
  onSelect: () => void;
}) {
  return (
    <Link disabled={disabled} onClick={onSelect}>
      <Text
        className={cx(
          'SelectBox',
          selected && 'SelectBox--selected',
          full && 'SelectBox--full',
          flush && 'SelectBox--flush',
          disabled && 'SelectBox--disabled'
        )}
        color="chalkboard"
        weight={selected ? 'semibold' : 'normal'}
        size="small">
        {label}
      </Text>
    </Link>
  );
}
